import React from "react";

/**
 * Renders a row of small flag emoji for the languages the user has chosen
 * to communicate in. Used in community cards, admin user list, and public profiles
 * so people see at a glance what language to write in.
 *
 * If the user has no preferred_languages declared, returns null (nothing shown).
 */
const FLAG_BY_LANG = {
  sk: { emoji: "🇸🇰", label: "Slovenčina" },
  en: { emoji: "🇬🇧", label: "English" },
  cs: { emoji: "🇨🇿", label: "Čeština" },
  de: { emoji: "🇩🇪", label: "Deutsch" },
  pl: { emoji: "🇵🇱", label: "Polski" },
  fr: { emoji: "🇫🇷", label: "Français" },
};

export default function LanguageFlags({ languages, size = "sm", max = 5, className = "" }) {
  if (!Array.isArray(languages) || languages.length === 0) return null;
  const fontSize = size === "lg" ? "text-base" : size === "md" ? "text-sm" : "text-xs";
  const items = languages.slice(0, max);
  return (
    <span
      data-testid="language-flags"
      className={`inline-flex items-center gap-0.5 ${fontSize} ${className}`}
      title={items.map((l) => FLAG_BY_LANG[l]?.label || l).join(" · ")}
    >
      {items.map((l) => (
        <span key={l} aria-label={FLAG_BY_LANG[l]?.label || l}>
          {FLAG_BY_LANG[l]?.emoji || "🏳️"}
        </span>
      ))}
    </span>
  );
}

export { FLAG_BY_LANG };
